import { render, staticRenderFns } from "./PanelGroup.vue?vue&type=template&id=48c369af&scoped=true"
import script from "./PanelGroup.vue?vue&type=script&lang=js"
export * from "./PanelGroup.vue?vue&type=script&lang=js"
import style0 from "./PanelGroup.vue?vue&type=style&index=0&id=48c369af&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c369af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\dm\\longda\\web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48c369af')) {
      api.createRecord('48c369af', component.options)
    } else {
      api.reload('48c369af', component.options)
    }
    module.hot.accept("./PanelGroup.vue?vue&type=template&id=48c369af&scoped=true", function () {
      api.rerender('48c369af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/PanelGroup.vue"
export default component.exports